<template>
    <div class="page">
        <div class="introduce">
            <!-- 成长权益介绍 -->
            <div class="title-b">
                <div class="t-icon icon0"></div>
                <div class="t-name">成长权益与活力值</div>
            </div>
            <div class="title-ss">1.什么是成长权益</div>
            <div
                class="r-content"
            >成长权益是拍拍贷为优质用户提供的特权服务体系。用户在拍拍贷的基础信息、交易信息及互动信息生成活力值并划分为不同用户等级。 等级越高的用户，可以享受拍拍贷提供更多的特权服务。</div>

            <div class="title-s">2.成长权益有哪些等级，如何提高等级？</div>
            <div class="r-content">
                成长权益有V0/V1/V2/V3四个等级，等级由用户的活力值决定，活力值达到一定数值要求即可提高会员等级。不同等级对应的活力值要求以页面展示为准。
                可见等级卡片上文字提示 。
            </div>

            <div class="title-s">3.活力值是什么？如何提高活力值？</div>
            <div class="r-content">
                活力值由基础分、交易分、互动分3个部分组成，依据您近12个月在拍拍贷的交易、互动等行为综合评估得出的用户价值分数。
                <p>活力值提高方法可见成长权益主页下方的升级攻略。</p>
            </div>

            <div class="title-s">4.基础分是什么，如何提高基础分？</div>
            <div class="r-content">基础分与您在平台的历史交易、互动、信用等级相关，每月3日前更新分值。保持更好的活跃度和信誉，可以在每月评估时获得更高的分数。</div>

            <div class="title-s">5.交易分是什么，如何提高交易分？</div>
            <div class="r-content">
                交易分与您在平台的借还款行为相关，分值实时变动。统计周期为在您成长权益激活后的近12个月。
                <p>借款成功后每满100元增加1份；</p>
                <p>每笔按时完成的成功还款可加5分；</p>
                <p>每笔借款申请逾期后将按日扣减10分。</p>
                <p>请保持良好信用，按时还款，有助于提高交易分。</p>
            </div>

            <div class="title-s">6.互动分是什么，如何提高互动分？</div>
            <div class="r-content">互动分与您对平台活动（包括APP端和微信端）的参与情况有关。与平台保持较好互动，参与更多活动任务，即可领取更多互动分。</div>

            <!-- 成长权益特权 -->
            <div class="title-b">
                <div class="t-icon icon2"></div>
                <div class="t-name">成长权益特权</div>
            </div>

            <div class="title-ss">1.成长权益特权有哪些？</div>
            <div class="r-content">
                特权涵盖权益日活动、提前结清免息券、生日礼券、优惠券福袋、实物礼品、专线客服等福利。
                <p>等级越高的用户，可以享受到越多的特权，具体的特权列表如下：</p>
            </div>
            <div class="rule-table1"></div>

            <div class="title-s">2.权益日活动是什么，如何参与？</div>
            <div class="r-content">
                权益日活动每月18号举行，用户在活动指定页面参与秒杀息费折扣券，会员等级越高的用户，获得的息费折扣券折扣越高。
                <p>息费折扣券数量有限，先到先得。</p>
            </div>
            <div class="title-s">3.生日礼券是什么，如何领取使用？</div>
            <div class="r-content">V1及以上等级的用户，在生日当月可以领取一张价值30元的免息折扣券。</div>
            <div class="title-s">4.生活券福袋是什么，如何使用？</div>
            <div class="r-content">V1及以上等级的用户，在生日当月可以领取一张价值30元的免息折扣券。</div>
            <div class="r-content">V1及以上等级的用户可以享受生活券福袋特权，包含超过20家品牌优惠券，覆盖生活出行/美食外卖/休闲娱乐/亲子教育等场景。</div>
            <div class="r-content">券的领取和使用在详情页面。已领取的优惠券，在降级后仍可前往查看和使用。优惠券的详细信息详见说明页面，部分需要在三方页面支付使用。</div>

            <div class="title-s">5.实物礼品有哪些，如何领取？</div>
            <div class="r-content">V1及以上等级的用户可以享受实物礼品特权，不同等级的用户可以领取的礼品类型及数量不同。详情以页面为准。</div>
            <div class="r-content">礼品一经领取，非礼品质量问题，不退不换。邮寄费用由拍拍贷提供，无需用户承担。</div>

            <div class="title-s">6.专线客服是什么，如何使用？</div>
            <div class="r-content">V3会员专享，拨打客服电话将获得客服专线服务，来电优先接听，问题优先解决。</div>

            <div class="title-s">7.提前还清免息费是什么？如何使用？</div>
            <div class="r-content">
                V1及以上等级的用户可以领取。不同等级每年可领张数不同（统计周期为当前节点过去365天，非自然年）。
                <p>降分掉级后仍可使用已领的券。</p>
            </div>
            <div class="r-content">
                <p>券的使用规则：</p>
                <p>· 可以在申请借款时使用。</p>
                <p>· 提前还清借款时，息费仅收取到当前账期，免去后续所有费用。</p>
            </div>

            <!-- 其他说明 -->
            <div class="title-b">
                <div class="t-icon icon3"></div>
                <div class="t-name">特别提示</div>
            </div>
            <div class="r-content">
                <p>· 拍拍贷对本活动持有法律允许范围内的解释权。</p>
                <p>· 若有疑问，可咨询客服400-184-8888（工作时间：8：00-20：00）</p>
                <p>· 以上奖品由拍拍贷提供与苹果公司无关。</p>
            </div>
            
            <div class="sep"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goBacktoHome
                    }
                ],
                titleView: {
                    text: '权益规则详情',
                    color: '#000000'
                },
                rightView: []
            }
        };
    },
    created() {
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
        }
    },
    methods: {
        goBacktoHome() {
            this.$router.push('/');
        },
    }
};
</script>

<style lang="less" scoped>
.page {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 18px;
    .title-b {
        display: flex;
        flex-direction: row;
        justify-items: center;
        margin-top: 25px;
        .t-icon {
            width: 23px;
            height: 23px;
            background-size: 100% 100%;
        }
        .icon0 {
            background-image: url('../../../../assets/img/rule-js@2x.png');
        }
        .icon1 {
            background-image: url('../../../../assets/img/rule-hl@2x.png');
        }
        .icon2 {
            background-image: url('../../../../assets/img/rule-sm@2x.png');
        }
        .icon3 {
            background-image: url('../../../../assets/img/rule-qt@2x.png');
        }
        .t-name {
            color: #d1b887;
            font-size: 17px;
            font-family: fzlt_bold;
            margin-left: 6px;
            margin-top: 4px;
        }
    }
    .title-s {
        margin-top: 34px;
        color: #292738;
        font-size: 14px;
        width: 100%;
        font-family: fzlt_bold;
    }
    .title-ss {
        margin-top: 24px;
        color: #292738;
        font-size: 14px;
        width: 100%;
        font-family: fzlt_bold;
    }
    .r-content {
        margin-top: 10px;
        color: #999dad;
        font-size: 13px;
        font-family: fzlt;
        line-height: 21px;
    }
    .rule-table1 {
        margin-top: 18px;
        width: 339px;
        height: 360px;
        background-size: 100% 100%;
        background-image: url('../../../../assets/img/rule-box2@2x.png');
    }
    .rule-table2 {
        margin-top: 18px;
        width: 339px;
        height: 68px;
        background-size: 100% 100%;
        background-image: url('../../../../assets/img/rule-box1@2x.png');
    }
    .sep {
        width: 100%;
        height: 30px;
    }
}
</style>